<template>
  <div class="flex flex-col items-center justify-between bg-neutral-100 min-h-screen">

    <Navbar/>

    <main id="main" class="mx-4 w-full bg-transparent px-0 md:mx-auto md:max-w-6xl md:rounded-3xl md:px-8 xl:px-0 md:pb-12 md:grow">
      <NuxtPage/>
    </main>

    <Footer :complete="true"/>

    <Modal v-if="shouldShowExitModal"
           v-model="exitModal"
           :modal="ModalsExit"
    />

    <ModalsDefault/>

    <UNotifications>
      <template #title="{ title }">{{ $t(title) }}</template>
      <template #description="{ description }">
        <span v-if="description">{{ $t(description) }}</span>
      </template>
    </UNotifications>

  </div>
</template>

<script setup lang="ts">
import { ModalsExit } from "#components"

const { exitModal, shouldShowExitModal } = useExitModal()
</script>
